import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

export default function SubPageShell({ title, tid, children, actions }) {
  const navigate = useNavigate();
  return (
    <div data-testid={tid} className="mx-auto max-w-3xl px-4 pb-16 sm:px-6">
      <header className="sticky top-14 z-30 -mx-4 flex items-center gap-2 border-b border-slate-100 bg-[#F8FAF7]/95 px-4 py-3 backdrop-blur-md sm:-mx-6 sm:px-6">
        <button
          data-testid={`${tid}-back`}
          onClick={() => navigate("/account")}
          aria-label="Back"
          className="rounded-full p-1.5 text-slate-700 transition hover:bg-teal-50 active:scale-90"
        >
          <ChevronLeft className="h-5 w-5" />
        </button>
        <h1 className="font-heading text-lg font-bold tracking-tight text-slate-900">{title}</h1>
        {actions && <div className="ml-auto">{actions}</div>}
      </header>
      <div className="pt-4">{children}</div>
    </div>
  );
}
